import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { fetchResourceActions } from '~src/resourceActions/actions/ResourceActions';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { updateBreadcrumbs } from '~src/spacesPlatform/actions/UpdateBreadcrumbsAction';
import { selectContentTotalLength } from '~src/spacesPlatform/selectors/ContentSelectors';

import { AppState } from '../../../../bootstrap/redux/state/AppState';
import { AllGroupsSpace, AllGroupsSpaceDispatchProps, AllGroupsSpaceOwnProps, AllGroupsSpaceStateProps } from './AllGroupsSpace';

const mapStateToProps: MapStateToProps<AllGroupsSpaceStateProps> = (state: AppState) => ({
  numberOfFetchedGroups: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
  canSessionUserManageUsers: SessionUserSelectors.canManageUsers(state),
  canSessionUserCreateGroup: getSessionManagementServiceInstance().canSessionUserProvisionGroups(),
});

const mapDispatchToProps: MapDispatchToProps<AllGroupsSpaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
  updateBreadcrumbs,
  fetchResourceActions,
}, dispatch);

export const ConnectedAllGroupsSpace: React.ComponentClass<AllGroupsSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(AllGroupsSpace);
